import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { Encoding, MarkType, MarkTypeOptions } from '@mode-vegas/vegas';
import { IconButtonComponent, TooltipDirective } from '@mode/capra';
import { RenderDataModel } from '@mode/charts/util-vegas';
import { AreaOptionsMenuComponent } from './area-options-menu.component';
import { BarOptionsMenuComponent } from './bar-options-menu.component';
import { getMarkLayerOptions, isSupportedMarkType } from './layer-options-menu-helpers';
import { LineOptionsMenuComponent } from './line-options-menu.component';

@Component({
  standalone: true,
  imports: [
    AreaOptionsMenuComponent,
    BarOptionsMenuComponent,
    CommonModule,
    TooltipDirective,
    IconButtonComponent,
    LineOptionsMenuComponent,
    MatLegacyMenuModule,
  ],
  selector: 'mode-layer-options-menu',
  templateUrl: './layer-options-menu.component.html',
  styleUrls: ['./layer-options-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayerOptionsMenuComponent implements OnChanges {
  @Input() model: RenderDataModel | undefined;
  @Input() encoding: Encoding | undefined;
  @Input() markType!: MarkType;
  @Input() seriesField: string | undefined;

  @Output() optionsChanged = new EventEmitter<MarkTypeOptions>();

  hasMarkOptions = false;
  markLayerOptions: MarkTypeOptions | undefined;
  isDisabled = false;
  tooltipText = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.markType) {
      this.hasMarkOptions = isSupportedMarkType(changes.markType.currentValue);
    }
    const layerOptions = getMarkLayerOptions(this.encoding, this.markType, this.seriesField);
    this.isDisabled = layerOptions === undefined;
    this.markLayerOptions = layerOptions !== undefined ? { ...layerOptions } : undefined;
    this.tooltipText = this.isDisabled
      ? 'There are multiple layers. To update mark settings, use the individual layers below.'
      : 'Configure settings for this layer.';
  }

  onMarkOptionsChanged(options: MarkTypeOptions) {
    this.optionsChanged.emit(options);
  }
}
